export default __webpack_public_path__ + "static/media/iconAsn.09eeeb0a.png";